export default __webpack_public_path__ + "538c97cde56b2736fa3a5e0d6031f174.png";